import service from '@/store/services/fms/cashier-service';

const state = {
  list: {},
  cashier: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashier) => {
    state.cashier = cashier;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((cashier) => { commit('SET_RESOURCE', cashier); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((cashier) => { commit('SET_RESOURCE', cashier); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((cashier) => { commit('SET_RESOURCE', cashier); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  cashier: state => state.cashier,
  page: state => state.meta.page,
};
 
const cashier = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default cashier;
